import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { DialogData } from '@app/shared/interfaces/lib/dynamic-pricing.interface';
import { SegmentEvent, SegmentIoService } from '@app/shared/services/segmentIo/segment-io.service';
import { UiModule } from '@app/ui';
import { MaterialModule } from '@app/ui/material.module';

@Component({
  standalone: true,
  selector: 'sbnb-dynamic-pricing-property-error-mobile-modal',
  templateUrl: './dynamic-pricing-property-error-mobile-modal.component.html',
  styleUrls: ['./dynamic-pricing-property-error-mobile-modal.component.scss'],
  imports: [CommonModule, UiModule, MaterialModule],
})
export class DynamicPricingPropertyErrorMobileModalComponent {
  public loading = false;

  constructor(
    public dialogRef: MatDialogRef<DynamicPricingPropertyErrorMobileModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: DialogData,
    private segmentIoService: SegmentIoService
  ) {}
  public closeModal(message?: string) {
    this.dialogRef.close(message);
  }
}
